import { render, staticRenderFns } from "./ViewOrderUserDetailForm.vue?vue&type=template&id=1a8fbc1a&"
import script from "./ViewOrderUserDetailForm.vue?vue&type=script&lang=js&"
export * from "./ViewOrderUserDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8fbc1a')) {
      api.createRecord('1a8fbc1a', component.options)
    } else {
      api.reload('1a8fbc1a', component.options)
    }
    module.hot.accept("./ViewOrderUserDetailForm.vue?vue&type=template&id=1a8fbc1a&", function () {
      api.rerender('1a8fbc1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/ViewOrderUserDetailForm.vue"
export default component.exports